import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatEnum'
})
export class FormatEnumPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    return value.replace(/_/g, ' ');
  }

}
